import React, { useState } from "react";

export default function TemplateFilter({
  search,
  setSearch,
  searchType,
  setSearchType,
  dataFilterType,
  setDataFilterType,
  handleSearch,
}) {
  const [dataTypeDropdownOpen, setDataTypeDropdownOpen] = useState(false);
  const [searchTypeDropdownOpen, setSearchTypeDropdownOpen] = useState(false);

  const dataTypes = [
    { value: "all", label: "전체" },
    { value: "rule", label: "회칙" },
    { value: "bylaw", label: "세칙" },
  ];

  const searchTypes = [
    { value: "title", label: "제목" },
    { value: "content", label: "내용" },
  ];

  const selectedDataType =
    dataTypes.find((item) => item.value === dataFilterType)?.label || "전체";

  const selectedSearchType =
    searchTypes.find((item) => item.value === searchType)?.label || "제목";

  return (
    <div className="regul-template-filter">
      <div className="regul-template-filter-left">
        <div className="regul-template-dropdown">
          <button
            className="regul-template-dropdown-btn"
            onClick={() => setDataTypeDropdownOpen((v) => !v)}
            type="button"
          >
            {selectedDataType}
            <svg
              width="14"
              height="8"
              viewBox="0 0 24 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                transform: dataTypeDropdownOpen
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            >
              <polyline points="2 2 12 10 22 2" />
            </svg>
          </button>

          {dataTypeDropdownOpen && (
            <ul className="regul-template-dropdown-list">
              {dataTypes.map((item) => (
                <li
                  key={item.value}
                  className={`regul-template-dropdown-item ${
                    dataFilterType === item.value ? "active" : ""
                  }`}
                  onClick={() => {
                    setDataFilterType(item.value);
                    setDataTypeDropdownOpen(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <div className="regul-template-filter-right">
        <div className="regul-template-dropdown">
          <button
            className="regul-template-dropdown-btn"
            onClick={() => setSearchTypeDropdownOpen((v) => !v)}
            type="button"
          >
            {selectedSearchType}
            <svg
              width="14"
              height="8"
              viewBox="0 0 24 12"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                transform: searchTypeDropdownOpen
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition: "transform 0.2s",
              }}
            >
              <polyline points="2 2 12 10 22 2" />
            </svg>
          </button>

          {searchTypeDropdownOpen && (
            <ul className="regul-template-dropdown-list">
              {searchTypes.map((item) => (
                <li
                  key={item.value}
                  className={`regul-template-dropdown-item ${
                    searchType === item.value ? "active" : ""
                  }`}
                  onClick={() => {
                    setSearchType(item.value);
                    setSearchTypeDropdownOpen(false);
                  }}
                >
                  {item.label}
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="regul-template-search-wrap">
          <input
            className="regul-template-search-input"
            type="text"
            placeholder="검색어를 입력하세요."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />

          <button
            className="regul-template-search-btn"
            onClick={handleSearch}
            type="button"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}